import React from 'react';
import FormField from "./FormField";
import Overview from "./Overview";
const ConfirmationStep = ({ pll, formData, setFormData, page, setPage, attributes }) => {
    const previousHandler = () => {
        setPage(page - 1);
    };
    return (React.createElement("div", { className: "step registration" },
        React.createElement("h2", { className: "h2-as-h1 top-title" },
            React.createElement("small", null, attributes.dispositif.name),
            React.createElement("br", null),
            pll("subscriptionFormStep2")),
        React.createElement(Overview, { pll: pll, formData: formData, attributes: attributes, showModules: true, showInformations: true }),
        React.createElement("div", { className: "section-wrapper registration" },
            React.createElement("button", { onClick: previousHandler, className: "Button" }, pll("Modifier mes informations")),
            React.createElement("div", { className: "informations function-date", dangerouslySetInnerHTML: { __html: pll("informationsFunctionDateFinalStep") } }),
            React.createElement("div", { className: "fields" },
                React.createElement(FormField, { pll: pll, type: "checkbox", label: pll("Je certifie que les informations fournies sont correctes"), name: "correct_data", formData: formData, setFormData: setFormData, required: true }),
                React.createElement(FormField, { pll: pll, type: "checkbox", label: pll("J'accepte la politique RGPD"), name: "consent", formData: formData, setFormData: setFormData, required: true }))),
        React.createElement("div", { className: "actions" },
            React.createElement("button", { onClick: previousHandler, className: "Link" }, pll("Retour")),
            React.createElement("button", { className: "Button" }, pll("Valider ma demande d'inscription")))));
};
export default ConfirmationStep;
